import React, { Fragment } from 'react';

import './styles.less';

const VolumeLevel = ({ percentage }) => {
  const style = { width: percentage };

  return (
    <Fragment>
      {/* We want the big slider scrubber to end at the end of the slider bar */}
      {/* rather than past it, so we make the slider shorter and add a fake */}
      {/* slider backround */}
      <div className="slider-extended-background" />
      <div className="video-player-volume-level" style={style}>
        <span />
      </div>
    </Fragment>
  );
};

export default VolumeLevel;
